export default {
  appName: '管理系统',
  yes: '是',
  no: '否',
  search: '搜索',
  reset: '重置',
  cancel: '取消',
  close: '关闭',
  confirm: '确定',
  save: '保存',
  edit: '编辑',
  copy: '复制',
  delete: '删除',
  actions: '操作',
  emptyDash: '—',
  adminFallback: '管理员',
  comingSoon: '功能开发中，敬请期待',
  refresh: '刷新',
  more: '更多'
}
